import React from 'react';
import { useAnalytics } from '../../context/AnalyticsContext';
import { Button } from '../ui/button';
import { Cookie, X } from 'lucide-react';

export function CookieConsent() {
    const { consentGiven, acceptCookies, declineCookies } = useAnalytics();

    // Don't show if consent already given (either way)
    if (consentGiven !== null) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card border-t border-border shadow-lg animate-in slide-in-from-bottom duration-300">
            <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <div className="flex items-start gap-3 flex-1">
                    <Cookie className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" />
                    <div>
                        <h3 className="font-semibold text-sm mb-1">Cookie-k és analitika</h3>
                        <p className="text-xs text-muted-foreground">
                            Az oldal működésének javítása érdekében anonim statisztikákat gyűjtünk a látogatói viselkedésről. 
                            Személyes adatokat nem tárolunk. A statisztikák segítenek megérteni, hogyan használják az oldalt.
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
                    <Button variant="outline" size="sm" onClick={declineCookies} className="flex-1 sm:flex-none">
                        <X className="w-4 h-4 mr-1" />
                        Elutasítom
                    </Button>
                    <Button size="sm" onClick={acceptCookies} className="flex-1 sm:flex-none">
                        Elfogadom
                    </Button>
                </div>
            </div>
        </div>
    );
}
